import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }

import { RACIData, RACIRole, RACITask } from "@/classes";
import type { Deleteable, RACIValue } from "@/classes/asset-management-plan";

import RichText from "@/components/base/inputs/RichText.vue";

import RoleAutocomplete from "../RoleAutocomplete.vue";
import { useAMPStore } from "@/store/asset-management-plan";
import RACIMatrix from "../raci/RACIMatrix.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RACI',
  props: {
    readonly: { type: Boolean }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useAMPStore();

const addTask = () => {
  const task = new RACITask();
  task.asset_management_plan = store.plan;
  task.asset_management_plan_id = store.plan.id;
  store.plan.raci_tasks.push(task);
};

const addRole = () => {
  const role = new RACIRole();
  role.asset_management_plan = store.plan;
  role.asset_management_plan_id = store.plan.id;
  store.plan.raci_roles.push(role);
};

const deleteTask = (task: RACITask) => {
  store.plan.raci_tasks = store.plan.raci_tasks.filter((t) => t.id !== task.id);
  emit("delete", task);
  const relatedData = store.plan.raci_data.filter(
    (d) => d.raci_task_id === task.id,
  );
  for (const data of relatedData) deleteData(data);
};
const deleteRole = (role: RACIRole) => {
  store.plan.raci_roles = store.plan.raci_roles.filter((r) => r.id !== role.id);
  emit("delete", role);
  const relatedData = store.plan.raci_data.filter(
    (d) => d.raci_role_id === role.id,
  );
  for (const data of relatedData) deleteData(data);
};

const deleteData = (data: RACIData) => {
  store.plan.raci_data = store.plan.raci_data.filter((d) => d.id !== data.id);
  emit("delete", data);
};

const setRACI = (task: RACITask, role: RACIRole, value: RACIValue | null) => {
  const data = store.plan.raci_data.find(
    (d) => d.raci_role_id === role.id && d.raci_task_id === task.id,
  );

  if (data) {
    data.value = value;
  } else {
    const newData = new RACIData();
    newData.asset_management_plan = store.plan;
    newData.asset_management_plan_id = store.plan.id;
    newData.raci_role_id = role.id;
    newData.raci_task_id = task.id;
    newData.value = value;
    store.plan.raci_data.push(newData);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      modelValue: _unref(store).plan.raci,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).plan.raci) = $event)),
      label: "2.1 RACI",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RACIMatrix, {
      plan: _unref(store).plan,
      readonly: _ctx.readonly,
      "onAdd:task": _cache[1] || (_cache[1] = ($event: any) => (addTask())),
      "onAdd:role": _cache[2] || (_cache[2] = ($event: any) => (addRole())),
      "onDelete:task": _cache[3] || (_cache[3] = ($event: any) => (deleteTask($event))),
      "onDelete:role": _cache[4] || (_cache[4] = ($event: any) => (deleteRole($event))),
      "onSet:raci": _cache[5] || (_cache[5] = ($event: any) => (setRACI($event.task, $event.role, $event.value)))
    }, null, 8, ["plan", "readonly"])
  ]))
}
}

})